module.exports = __webpack_public_path__ + "img/29.af2f8631.png";